import { render } from "./LessonComplete.vue?vue&type=template&id=966c9b22&scoped=true"
import script from "./LessonComplete.vue?vue&type=script&lang=js"
export * from "./LessonComplete.vue?vue&type=script&lang=js"

import "./LessonComplete.vue?vue&type=style&index=0&id=966c9b22&lang=css"
import "./LessonComplete.vue?vue&type=style&index=1&id=966c9b22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-966c9b22"]])

export default __exports__